export default "__VITE_ASSET__BdDcntjv__"